
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9263"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9263"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $2sqaL = parcelRequire("2sqaL");
const $df52ef29555cc1e5$var$SB_URL = "https://thapqeodawxffacnljij.supabase.co";
const $df52ef29555cc1e5$var$SB_KEY = "sb_publishable_TZQOtUq1RwjDGBpWDb92UA_KZwAOHUS";
const $df52ef29555cc1e5$var$sb = (0, $2sqaL.createClient)($df52ef29555cc1e5$var$SB_URL, $df52ef29555cc1e5$var$SB_KEY);
const $df52ef29555cc1e5$var$$ = (id)=>document.getElementById(id);
let $df52ef29555cc1e5$var$reviews = [];
let $df52ef29555cc1e5$var$currentReviewId = null;
let $df52ef29555cc1e5$var$sections = [];
let $df52ef29555cc1e5$var$dragIdx = null;
// =============================================================================
// HELPERS
// =============================================================================
function $df52ef29555cc1e5$var$getCategory() {
    return document.querySelector('input[name="fCategory"]:checked')?.value || "game";
}
function $df52ef29555cc1e5$var$buildStars(score) {
    const val = parseFloat(score);
    if (isNaN(val)) return {
        html: "\u2606\u2606\u2606\u2606\u2606\u2606\u2606\u2606\u2606\u2606",
        text: "\u2014"
    };
    const lit = Math.round(Math.min(10, Math.max(0, val)));
    const dark = 10 - lit;
    return {
        html: '<span class="lit">' + "\u2605".repeat(lit) + "</span>" + "\u2606".repeat(dark),
        text: val.toFixed(1)
    };
}
// =============================================================================
// LIVE PREVIEW
// =============================================================================
function $df52ef29555cc1e5$var$updateLivePreview() {
    const title = $df52ef29555cc1e5$var$$("fTitle").value;
    const summary = $df52ef29555cc1e5$var$$("fSummary").value;
    const score = $df52ef29555cc1e5$var$$("fScore").value;
    const banner = $df52ef29555cc1e5$var$$("fBanner").value;
    const cat = $df52ef29555cc1e5$var$getCategory();
    $df52ef29555cc1e5$var$$("pTitle").textContent = title || "T\xedtulo da Review";
    $df52ef29555cc1e5$var$$("pSummary").textContent = summary;
    const { html: html, text: text } = $df52ef29555cc1e5$var$buildStars(score);
    $df52ef29555cc1e5$var$$("pStars").innerHTML = html;
    $df52ef29555cc1e5$var$$("pScore").textContent = score ? text : "\u2014";
    const badge = $df52ef29555cc1e5$var$$("pCategoryBadge");
    if (cat === "anime") {
        badge.textContent = "\uD83C\uDF8E Anime / Mang\xe1";
        badge.className = "preview-card__badge preview-card__badge--anime";
    } else {
        badge.textContent = "\uD83C\uDFAE Jogo";
        badge.className = "preview-card__badge preview-card__badge--game";
    }
    const wrap = $df52ef29555cc1e5$var$$("pBannerWrap");
    if (banner) wrap.innerHTML = `<img src="${banner}" alt="" onerror="this.style.display='none'" />`;
    else wrap.innerHTML = `<div class="preview-card__banner-placeholder">sem banner</div>`;
    const html2 = $df52ef29555cc1e5$var$sections.map((s)=>{
        if (s.type === "paragraph") return s.text ? `<p>${s.text}</p>` : "";
        if (s.type === "quote") return s.text ? `<blockquote>"${s.text}"</blockquote>` : "";
        if (s.type === "image") return s.url ? `<img src="${s.url}" alt="">` : "";
        if (s.type === "video") return `<div class="preview-card__video-ph">\u{1F3A5} ${s.url || "URL do v\xeddeo"}</div>`;
        return "";
    }).join("");
    $df52ef29555cc1e5$var$$("pContent").innerHTML = html2 || '<p class="preview-card__empty-hint">conte\xfado aparece aqui\u2026</p>';
}
[
    "fTitle",
    "fSummary",
    "fScore",
    "fBanner"
].forEach((id)=>$df52ef29555cc1e5$var$$(id).addEventListener("input", $df52ef29555cc1e5$var$updateLivePreview));
document.querySelectorAll('input[name="fCategory"]').forEach((r)=>r.addEventListener("change", $df52ef29555cc1e5$var$updateLivePreview));
// =============================================================================
// SECTIONS — render
// =============================================================================
function $df52ef29555cc1e5$var$renderSections() {
    const wrapper = $df52ef29555cc1e5$var$$("sectionsWrapper");
    wrapper.innerHTML = "";
    $df52ef29555cc1e5$var$sections.forEach((s, i)=>{
        const block = document.createElement("div");
        block.className = "sec-block";
        block.draggable = true;
        const typeClass = {
            paragraph: "para",
            quote: "quote",
            image: "image",
            video: "video"
        }[s.type] || "para";
        const typeLabel = {
            paragraph: "Par\xe1grafo",
            quote: "Cita\xe7\xe3o",
            image: "Imagem",
            video: "V\xeddeo"
        }[s.type] || s.type;
        let body = "";
        if (s.type === "paragraph") body = `<textarea class="sec-block__textarea" placeholder="Escreva aqui\u{2026}">${s.text || ""}</textarea>`;
        else if (s.type === "quote") body = `<textarea class="sec-block__textarea" style="min-height:60px" placeholder="Cita\xe7\xe3o\u{2026}">${s.text || ""}</textarea>`;
        else if (s.type === "image") // Upload area idêntico ao banner + campo URL alternativo
        body = `
        <div class="sec-block__img-wrap">
          <div class="sec-block__img-upload" data-upload-area>
            <input type="file" accept="image/*" data-file-input />
            <img class="sec-block__img-preview-thumb" data-preview alt="" />
            <div class="sec-block__img-text">
              <div class="sec-block__img-filename" data-filename>\u{1F4C1} Clique para selecionar</div>
              <div class="sec-block__img-hint">JPG, PNG, WebP</div>
            </div>
          </div>
          <span class="sec-block__img-status" data-status></span>
          <div class="sec-block__img-divider">ou cole uma URL</div>
          <input
            type="text"
            class="sec-block__img-url-input"
            placeholder="https://\u{2026}"
            value="${s.url || ""}"
            data-url-input
          />
        </div>`;
        else if (s.type === "video") body = `
        <div class="sec-block__video-wrap">
          <div class="sec-block__video-input">
            <span class="sec-block__video-icon">\u{25B6}</span>
            <input type="text" placeholder="URL do YouTube\u{2026}" value="${s.url || ""}" />
          </div>
        </div>`;
        block.innerHTML = `
      <div class="sec-block__bar">
        <span class="sec-block__type sec-block__type--${typeClass}">${typeLabel}</span>
        <div class="sec-block__actions">
          <button class="sec-block__btn" data-move="-1" data-idx="${i}" title="Subir"  ${i === 0 ? "disabled" : ""}>\u{2191}</button>
          <button class="sec-block__btn" data-move="1"  data-idx="${i}" title="Descer" ${i === $df52ef29555cc1e5$var$sections.length - 1 ? "disabled" : ""}>\u{2193}</button>
          <button class="sec-block__btn sec-block__btn--del" data-del="${i}" title="Remover">\u{2715}</button>
        </div>
      </div>
      ${body}
    `;
        // ── Listeners por tipo ──────────────────────────────────────────────────
        if (s.type === "paragraph" || s.type === "quote") {
            const ta = block.querySelector("textarea");
            ta.addEventListener("input", (e)=>{
                s.text = e.target.value;
                $df52ef29555cc1e5$var$updateLivePreview();
            });
            ta.addEventListener("input", ()=>{
                ta.style.height = "auto";
                ta.style.height = ta.scrollHeight + "px";
            });
            requestAnimationFrame(()=>{
                ta.style.height = "auto";
                ta.style.height = ta.scrollHeight + "px";
            });
        } else if (s.type === "image") {
            // Upload de arquivo
            const area = block.querySelector("[data-upload-area]");
            const fileIn = block.querySelector("[data-file-input]");
            const preview = block.querySelector("[data-preview]");
            const filename = block.querySelector("[data-filename]");
            const status = block.querySelector("[data-status]");
            const urlInput = block.querySelector("[data-url-input]");
            area.addEventListener("click", ()=>fileIn.click());
            fileIn.addEventListener("change", async ()=>{
                const file = fileIn.files[0];
                if (!file) return;
                filename.textContent = file.name;
                status.textContent = "Enviando\u2026";
                // Preview local imediato
                const reader = new FileReader();
                reader.onload = (e)=>{
                    preview.src = e.target.result;
                    preview.style.display = "block";
                };
                reader.readAsDataURL(file);
                const ext = file.name.split(".").pop();
                const path = `${Date.now()}.${ext}`;
                const { error: error } = await $df52ef29555cc1e5$var$sb.storage.from("section-images").upload(path, file, {
                    upsert: true
                });
                if (error) {
                    status.textContent = "\u274C " + error.message;
                    return;
                }
                const { data: urlData } = $df52ef29555cc1e5$var$sb.storage.from("section-images").getPublicUrl(path);
                s.url = urlData.publicUrl;
                urlInput.value = s.url;
                status.textContent = "\u2705 Enviado";
                $df52ef29555cc1e5$var$updateLivePreview();
            });
            // URL digitada manualmente
            urlInput.addEventListener("input", (e)=>{
                s.url = e.target.value;
                // Limpa preview do upload se o usuário digitar URL
                preview.style.display = "none";
                filename.textContent = "\uD83D\uDCC1 Clique para selecionar";
                status.textContent = "";
                $df52ef29555cc1e5$var$updateLivePreview();
            });
        } else if (s.type === "video") {
            const input = block.querySelector('input[type="text"]');
            input.addEventListener("input", (e)=>{
                s.url = e.target.value;
                $df52ef29555cc1e5$var$updateLivePreview();
            });
        }
        // ── Drag & drop ─────────────────────────────────────────────────────────
        block.addEventListener("dragstart", ()=>{
            $df52ef29555cc1e5$var$dragIdx = i;
            block.classList.add("sec-block--dragging");
        });
        block.addEventListener("dragend", ()=>block.classList.remove("sec-block--dragging"));
        block.addEventListener("dragover", (e)=>{
            e.preventDefault();
            block.classList.add("sec-block--drag-over");
        });
        block.addEventListener("dragleave", ()=>block.classList.remove("sec-block--drag-over"));
        block.addEventListener("drop", (e)=>{
            e.preventDefault();
            block.classList.remove("sec-block--drag-over");
            if ($df52ef29555cc1e5$var$dragIdx !== null && $df52ef29555cc1e5$var$dragIdx !== i) {
                const moved = $df52ef29555cc1e5$var$sections.splice($df52ef29555cc1e5$var$dragIdx, 1)[0];
                $df52ef29555cc1e5$var$sections.splice(i, 0, moved);
                $df52ef29555cc1e5$var$renderSections();
            }
        });
        wrapper.appendChild(block);
    });
    // Botões mover / deletar
    wrapper.querySelectorAll("[data-move]").forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            const idx = +btn.dataset.idx;
            const dest = idx + +btn.dataset.move;
            if (dest < 0 || dest >= $df52ef29555cc1e5$var$sections.length) return;
            [$df52ef29555cc1e5$var$sections[idx], $df52ef29555cc1e5$var$sections[dest]] = [
                $df52ef29555cc1e5$var$sections[dest],
                $df52ef29555cc1e5$var$sections[idx]
            ];
            $df52ef29555cc1e5$var$renderSections();
        });
    });
    wrapper.querySelectorAll("[data-del]").forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            $df52ef29555cc1e5$var$sections.splice(+btn.dataset.del, 1);
            $df52ef29555cc1e5$var$renderSections();
        });
    });
    $df52ef29555cc1e5$var$updateLivePreview();
}
// =============================================================================
// ADD SECTIONS
// =============================================================================
$df52ef29555cc1e5$var$$("addText").addEventListener("click", ()=>{
    $df52ef29555cc1e5$var$sections.push({
        type: "paragraph",
        text: ""
    });
    $df52ef29555cc1e5$var$renderSections();
});
$df52ef29555cc1e5$var$$("addQuote").addEventListener("click", ()=>{
    $df52ef29555cc1e5$var$sections.push({
        type: "quote",
        text: ""
    });
    $df52ef29555cc1e5$var$renderSections();
});
$df52ef29555cc1e5$var$$("addImage").addEventListener("click", ()=>{
    $df52ef29555cc1e5$var$sections.push({
        type: "image",
        url: ""
    });
    $df52ef29555cc1e5$var$renderSections();
});
$df52ef29555cc1e5$var$$("addVideo").addEventListener("click", ()=>{
    $df52ef29555cc1e5$var$sections.push({
        type: "video",
        url: ""
    });
    $df52ef29555cc1e5$var$renderSections();
});
// =============================================================================
// UPLOAD (banner + cover)
// =============================================================================
function $df52ef29555cc1e5$var$setupUpload({ areaId: areaId, fileInputId: fileInputId, previewId: previewId, labelId: labelId, statusId: statusId, hiddenId: hiddenId, bucket: bucket }) {
    const area = $df52ef29555cc1e5$var$$(areaId);
    const fileIn = $df52ef29555cc1e5$var$$(fileInputId);
    const preview = $df52ef29555cc1e5$var$$(previewId);
    const label = $df52ef29555cc1e5$var$$(labelId);
    const status = $df52ef29555cc1e5$var$$(statusId);
    const hidden = $df52ef29555cc1e5$var$$(hiddenId);
    area.addEventListener("click", ()=>fileIn.click());
    fileIn.addEventListener("change", async ()=>{
        const file = fileIn.files[0];
        if (!file) return;
        label.textContent = file.name;
        status.textContent = "Enviando\u2026";
        const reader = new FileReader();
        reader.onload = (e)=>{
            preview.src = e.target.result;
            preview.style.display = "block";
        };
        reader.readAsDataURL(file);
        const ext = file.name.split(".").pop();
        const path = `${Date.now()}.${ext}`;
        const { error: error } = await $df52ef29555cc1e5$var$sb.storage.from(bucket).upload(path, file, {
            upsert: true
        });
        if (error) {
            status.textContent = "\u274C " + error.message;
            return;
        }
        const { data: urlData } = $df52ef29555cc1e5$var$sb.storage.from(bucket).getPublicUrl(path);
        hidden.value = urlData.publicUrl;
        status.textContent = "\u2705 Enviado";
        $df52ef29555cc1e5$var$updateLivePreview();
    });
}
$df52ef29555cc1e5$var$setupUpload({
    areaId: "bannerUploadArea",
    fileInputId: "fBannerFile",
    previewId: "bannerPreview",
    labelId: "bannerUploadLabel",
    statusId: "bannerStatus",
    hiddenId: "fBanner",
    bucket: "banners"
});
$df52ef29555cc1e5$var$setupUpload({
    areaId: "coverUploadArea",
    fileInputId: "fCoverFile",
    previewId: "coverPreview",
    labelId: "coverUploadLabel",
    statusId: "coverStatus",
    hiddenId: "fCover",
    bucket: "covers"
});
// =============================================================================
// SAVE
// =============================================================================
$df52ef29555cc1e5$var$$("saveReviewBtn").addEventListener("click", async ()=>{
    const btn = $df52ef29555cc1e5$var$$("saveReviewBtn");
    btn.disabled = true;
    btn.textContent = "Salvando\u2026";
    const msg = $df52ef29555cc1e5$var$$("saveMsg");
    msg.style.display = "none";
    const payload = {
        title: $df52ef29555cc1e5$var$$("fTitle").value.trim(),
        slug: $df52ef29555cc1e5$var$$("fSlug").value.trim(),
        summary: $df52ef29555cc1e5$var$$("fSummary").value.trim(),
        platforms: $df52ef29555cc1e5$var$$("fPlatforms").value.trim(),
        score: parseFloat($df52ef29555cc1e5$var$$("fScore").value) || 0,
        banner_url: $df52ef29555cc1e5$var$$("fBanner").value,
        cover_url: $df52ef29555cc1e5$var$$("fCover").value,
        category: $df52ef29555cc1e5$var$getCategory(),
        sections: $df52ef29555cc1e5$var$sections,
        featured: $df52ef29555cc1e5$var$$("fFeatured").checked
    };
    let error;
    if ($df52ef29555cc1e5$var$currentReviewId) ({ error: error } = await $df52ef29555cc1e5$var$sb.from("reviews").update(payload).eq("id", $df52ef29555cc1e5$var$currentReviewId));
    else ({ error: error } = await $df52ef29555cc1e5$var$sb.from("reviews").insert([
        payload
    ]));
    if (error) {
        msg.className = "editor__msg editor__msg--error";
        msg.textContent = "\u274C Erro: " + error.message;
        msg.style.display = "block";
    } else {
        msg.className = "editor__msg editor__msg--success";
        msg.textContent = "\u2705 Salvo com sucesso!";
        msg.style.display = "block";
        await $df52ef29555cc1e5$var$loadReviews();
    }
    btn.disabled = false;
    btn.textContent = "\u2615 Salvar";
});
// =============================================================================
// DELETE
// =============================================================================
$df52ef29555cc1e5$var$$("deleteReviewBtn").addEventListener("click", async ()=>{
    if (!$df52ef29555cc1e5$var$currentReviewId) return;
    if (!confirm("Excluir esta review definitivamente?")) return;
    const { error: error } = await $df52ef29555cc1e5$var$sb.from("reviews").delete().eq("id", $df52ef29555cc1e5$var$currentReviewId);
    if (error) {
        alert("Erro: " + error.message);
        return;
    }
    $df52ef29555cc1e5$var$currentReviewId = null;
    $df52ef29555cc1e5$var$$("editorContent").style.display = "none";
    $df52ef29555cc1e5$var$$("editorPlaceholder").style.display = "flex";
    await $df52ef29555cc1e5$var$loadReviews();
});
// =============================================================================
// LOAD REVIEWS
// =============================================================================
async function $df52ef29555cc1e5$var$loadReviews() {
    const { data: data, error: error } = await $df52ef29555cc1e5$var$sb.from("reviews").select("id, title, slug, summary, platforms, score, banner_url, cover_url, category, sections, featured").order("created_at", {
        ascending: false
    });
    if (error) {
        console.error("loadReviews:", error);
        return;
    }
    $df52ef29555cc1e5$var$reviews = data || [];
    $df52ef29555cc1e5$var$$("reviewCount").textContent = $df52ef29555cc1e5$var$reviews.length;
    const list = $df52ef29555cc1e5$var$$("reviewList");
    if (!$df52ef29555cc1e5$var$reviews.length) {
        list.innerHTML = '<p class="sidebar__loading">Nenhuma review ainda.</p>';
        return;
    }
    $df52ef29555cc1e5$var$renderSidebarList();
}
function $df52ef29555cc1e5$var$renderSidebarList() {
    const list = $df52ef29555cc1e5$var$$("reviewList");
    const query = ($df52ef29555cc1e5$var$$("sidebarSearch")?.value || "").trim().toLowerCase();
    const filtered = query ? $df52ef29555cc1e5$var$reviews.filter((r)=>r.title?.toLowerCase().includes(query)) : $df52ef29555cc1e5$var$reviews;
    if (!filtered.length) {
        list.innerHTML = `<p class="sidebar__loading">${query ? "Nenhum resultado." : "Nenhuma review ainda."}</p>`;
        return;
    }
    list.innerHTML = filtered.map((r)=>`
    <div class="review-item ${r.id === $df52ef29555cc1e5$var$currentReviewId ? "review-item--active" : ""}" data-id="${r.id}">
      <img class="review-item__thumb" src="${r.cover_url || r.banner_url || ""}" alt="" onerror="this.style.visibility='hidden'" />
      <div class="review-item__info">
        <p class="review-item__title">${r.featured ? "\u2B50 " : ""}${r.title || "Sem t\xedtulo"}</p>
        <p class="review-item__meta review-item__meta--${r.category || "game"}">
          ${r.category === "anime" ? "\uD83C\uDF8E Anime" : "\uD83C\uDFAE Jogo"}${r.slug ? " \xb7 " + r.slug : ""}
        </p>
      </div>
    </div>
  `).join("");
    list.querySelectorAll(".review-item").forEach((el)=>{
        el.addEventListener("click", ()=>{
            const rev = $df52ef29555cc1e5$var$reviews.find((r)=>r.id == el.dataset.id);
            if (rev) $df52ef29555cc1e5$var$openReview(rev);
        });
    });
}
document.addEventListener("DOMContentLoaded", ()=>{
    $df52ef29555cc1e5$var$$("sidebarSearch")?.addEventListener("input", $df52ef29555cc1e5$var$renderSidebarList);
});
// =============================================================================
// OPEN REVIEW
// =============================================================================
function $df52ef29555cc1e5$var$openReview(rev) {
    $df52ef29555cc1e5$var$currentReviewId = rev.id;
    $df52ef29555cc1e5$var$$("editorPlaceholder").style.display = "none";
    $df52ef29555cc1e5$var$$("editorContent").style.display = "block";
    $df52ef29555cc1e5$var$$("deleteReviewBtn").style.display = "inline-flex";
    $df52ef29555cc1e5$var$$("editorTitle").textContent = rev.title || "Sem t\xedtulo";
    $df52ef29555cc1e5$var$$("saveMsg").style.display = "none";
    $df52ef29555cc1e5$var$$("fTitle").value = rev.title || "";
    $df52ef29555cc1e5$var$$("fSlug").value = rev.slug || "";
    $df52ef29555cc1e5$var$$("fSummary").value = rev.summary || "";
    $df52ef29555cc1e5$var$$("fPlatforms").value = rev.platforms || "";
    $df52ef29555cc1e5$var$$("fScore").value = rev.score ?? "";
    $df52ef29555cc1e5$var$$("fBanner").value = rev.banner_url || "";
    $df52ef29555cc1e5$var$$("fCover").value = rev.cover_url || "";
    $df52ef29555cc1e5$var$$("fFeatured").checked = rev.featured ?? false;
    const bp = $df52ef29555cc1e5$var$$("bannerPreview");
    if (rev.banner_url) {
        bp.src = rev.banner_url;
        bp.style.display = "block";
        $df52ef29555cc1e5$var$$("bannerUploadLabel").textContent = "Banner carregado";
    } else {
        bp.style.display = "none";
        $df52ef29555cc1e5$var$$("bannerUploadLabel").textContent = "\uD83D\uDCC1 Clique para selecionar";
    }
    const cp = $df52ef29555cc1e5$var$$("coverPreview");
    if (rev.cover_url) {
        cp.src = rev.cover_url;
        cp.style.display = "block";
        $df52ef29555cc1e5$var$$("coverUploadLabel").textContent = "Capa carregada";
    } else {
        cp.style.display = "none";
        $df52ef29555cc1e5$var$$("coverUploadLabel").textContent = "\uD83D\uDCC1 Clique para selecionar";
    }
    const radio = document.querySelector(`input[name="fCategory"][value="${rev.category || "game"}"]`);
    if (radio) radio.checked = true;
    $df52ef29555cc1e5$var$sections = Array.isArray(rev.sections) ? rev.sections : [];
    $df52ef29555cc1e5$var$renderSections();
    $df52ef29555cc1e5$var$$("editorPanel").scrollTo({
        top: 0,
        behavior: "smooth"
    });
}
// =============================================================================
// NEW REVIEW
// =============================================================================
$df52ef29555cc1e5$var$$("newReviewBtn").addEventListener("click", ()=>{
    $df52ef29555cc1e5$var$currentReviewId = null;
    $df52ef29555cc1e5$var$$("editorPlaceholder").style.display = "none";
    $df52ef29555cc1e5$var$$("editorContent").style.display = "block";
    $df52ef29555cc1e5$var$$("deleteReviewBtn").style.display = "none";
    $df52ef29555cc1e5$var$$("editorTitle").textContent = "Nova review";
    $df52ef29555cc1e5$var$$("saveMsg").style.display = "none";
    $df52ef29555cc1e5$var$$("fTitle").value = $df52ef29555cc1e5$var$$("fSlug").value = $df52ef29555cc1e5$var$$("fSummary").value = $df52ef29555cc1e5$var$$("fPlatforms").value = $df52ef29555cc1e5$var$$("fScore").value = $df52ef29555cc1e5$var$$("fBanner").value = $df52ef29555cc1e5$var$$("fCover").value = "";
    $df52ef29555cc1e5$var$$("fFeatured").checked = false;
    const bp = $df52ef29555cc1e5$var$$("bannerPreview");
    bp.style.display = "none";
    $df52ef29555cc1e5$var$$("bannerUploadLabel").textContent = "\uD83D\uDCC1 Clique para selecionar";
    const cp = $df52ef29555cc1e5$var$$("coverPreview");
    cp.style.display = "none";
    $df52ef29555cc1e5$var$$("coverUploadLabel").textContent = "\uD83D\uDCC1 Clique para selecionar";
    document.querySelector('input[name="fCategory"][value="game"]').checked = true;
    $df52ef29555cc1e5$var$sections = [];
    $df52ef29555cc1e5$var$renderSections();
});
// =============================================================================
// LOGIN / LOGOUT
// =============================================================================
$df52ef29555cc1e5$var$$("loginBtn").addEventListener("click", async ()=>{
    const email = $df52ef29555cc1e5$var$$("loginEmail").value.trim();
    const password = $df52ef29555cc1e5$var$$("loginPassword").value;
    const msg = $df52ef29555cc1e5$var$$("loginMsg");
    if (!email || !password) {
        msg.className = "login__msg login__msg--error";
        msg.textContent = "Preencha e-mail e senha.";
        return;
    }
    msg.className = "login__msg";
    msg.textContent = "Entrando\u2026";
    const { error: error } = await $df52ef29555cc1e5$var$sb.auth.signInWithPassword({
        email: email,
        password: password
    });
    if (error) {
        msg.className = "login__msg login__msg--error";
        msg.textContent = "Credenciais inv\xe1lidas.";
    }
});
$df52ef29555cc1e5$var$$("loginPassword").addEventListener("keydown", (e)=>{
    if (e.key === "Enter") $df52ef29555cc1e5$var$$("loginBtn").click();
});
$df52ef29555cc1e5$var$$("logoutBtn").addEventListener("click", async ()=>{
    await $df52ef29555cc1e5$var$sb.auth.signOut();
});
// =============================================================================
// AUTH STATE
// =============================================================================
$df52ef29555cc1e5$var$sb.auth.onAuthStateChange((event, session)=>{
    if (session) {
        $df52ef29555cc1e5$var$$("loginScreen").style.display = "none";
        $df52ef29555cc1e5$var$$("adminScreen").style.display = "flex";
        $df52ef29555cc1e5$var$$("userEmail").textContent = session.user.email;
        $df52ef29555cc1e5$var$$("loginMsg").textContent = "";
        $df52ef29555cc1e5$var$loadReviews();
    } else {
        $df52ef29555cc1e5$var$$("adminScreen").style.display = "none";
        $df52ef29555cc1e5$var$$("loginScreen").style.display = "flex";
    }
});


//# sourceMappingURL=admin.ea7be8b6.js.map
